import React, { useState } from "react";

function Create() {
  const [file, setFile] = useState("0");
  const [type, setType] = useState("0");
  const [size, setSize] = useState("0");
  const [text, setText] = useState("0");
  const [street, setStreet] = useState("0"); // 1. הוספת state לרחוב

  const fileChange = (e) => {
    if (e.target.files[0].size > 10 * 1024 * 1024) {
      alert("הקובץ גדול יותר מ-10MB");
      setFile("0");
      return;
    }
    setFile(e.target.files[0]);
  };

  const typeChange = (e) => setType(e.target.value);
  const sizeChange = (e) => setSize(e.target.value);
  const textChange = (e) => setText(e.target.value);
  const streetChange = (e) => setStreet(e.target.value); // 2. מאזין לקלט רחוב

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("size", size);
    formData.append("text", text);
    formData.append("street", street); // 3. הוספת לרשימת השליחה

    await fetch("/create", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.addit) {
          alert("התמונה נשלחה לבדיקה ותעלה לאתר לאחר אישורה.");
          window.location = "/create";
        } else {
          alert(res.err);
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="container mt-5" dir="rtl">
      <div className="card shadow p-4">
        <h2 className="text-center mb-3">הוספת דירה חדשה</h2>
        <p className="text-center text-muted">
          נא למלא את כל הפרטים ולהעלות תמונה
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">קטגוריית הדירה</label>
            <select
              className="form-select"
              onChange={typeChange}
              required
            >
              <option value="">בחר קטגוריה</option>
              <option value="home_shabat">דירה לשבת</option>
              <option value="sal">דירות למכירה</option>
              <option value="kait">דירות להשכרה</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">גודל הדירה (מ"ר)</label>
            <input
              type="number"
              className="form-control"
              onChange={sizeChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">רחוב</label>
            <input
              type="text"
              className="form-control"
              maxLength="100"
              onChange={streetChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">תיאור קצר (עד 200 תווים)</label>
            <input
              type="text"
              className="form-control"
              maxLength="200"
              onChange={textChange}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label">העלאת תמונה (עד 10MB)</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={fileChange}
              required
            />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary">
              שליחה
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Create;
